import { Button } from "@/shared/components/ui/button";
import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/shared/components/ui/form";
import { Upload, X } from "lucide-react";
import { memo } from "react";

interface ProductPhotoUploadProps {
  photoPreview: string | null;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemovePhoto: () => void;
}

export const ProductPhotoUpload = memo(function ProductPhotoUpload({
  photoPreview,
  onFileChange,
  onRemovePhoto,
}: ProductPhotoUploadProps) {
  return (
    <FormItem>
      <FormLabel>Foto do Produto</FormLabel>
      <FormControl>
        <div className="space-y-4">
          {photoPreview ? (
            <div className="relative">
              <img
                src={photoPreview}
                alt="Preview"
                className="w-full h-48 object-cover rounded-md border"
              />
              <Button
                type="button"
                variant="destructive"
                size="icon-sm"
                className="absolute top-2 right-2"
                onClick={onRemovePhoto}
                title="Remover foto"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          ) : (
            <div className="border-2 border-dashed rounded-md p-6 text-center hover:border-primary/50 transition-colors">
              <Upload className="w-8 h-8 mx-auto mb-2 text-muted-foreground" />
              <label
                htmlFor="photo-upload"
                className="cursor-pointer text-sm text-muted-foreground hover:text-primary"
              >
                Clique para selecionar uma imagem
                <br />
                <span className="text-xs">PNG, JPG até 5MB</span>
              </label>
              <input
                id="photo-upload"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={onFileChange}
              />
            </div>
          )}
        </div>
      </FormControl>
      <FormMessage />
    </FormItem>
  );
});
